import { useCallback } from 'react';
import { useMenuNavigation } from '../../hooks/menu/useMenuNavigation';
import { closeInterface } from '../../services/InterfaceService';
import './UnknownInterfaceScreen.scss';

interface Props {
  id: string;
}

/**
 * Fallback shown when an interface id is opened that isn't registered in
 * INTERFACE_REGISTRY. Always provides a way to quit so the game can never
 * be left frozen by a typo or a stale config.
 */
export const UnknownInterfaceScreen = ({ id }: Props) => {
  const close = useCallback(() => {
    closeInterface();
  }, []);

  const { containerRef } = useMenuNavigation({
    onConfirm: close,
    onCancel: close,
    onPause: close,
  });

  return (
    <div className="unknown-iface-overlay">
      <div className="unknown-iface-panel" ref={containerRef}>
        <h2 className="unknown-iface-title">Interface inconnue</h2>
        <p className="unknown-iface-message">
          Aucune interface enregistrée pour l'identifiant :
        </p>
        <code className="unknown-iface-id">{id}</code>
        <div
          className="unknown-iface-btn"
          data-nav-row={0}
          data-nav-col={0}
          data-nav-id="close"
        >
          Fermer
        </div>
      </div>
    </div>
  );
};
